import { createI18n } from 'vue-i18n'

import { cloneObject } from '@dogfy/lib/utils'

import i18nGlobalConfig from '@dogfy/lang/i18n.config'

import i18nLocalConfig from '@/lang/i18n.config'

const config = cloneObject(i18nGlobalConfig)

for (const locale in i18nLocalConfig.messages) {
  config.messages[locale] = { ...i18nGlobalConfig.messages[locale], ...i18nLocalConfig.messages[locale] }
}

const i18n = createI18n(config)

export default i18n
